import { makeStyles } from '@material-ui/styles';
import useTypeTracking from '../../../../analytics';

import { Text, MainButton, Settings } from '@bizzabo/design-system';
import { UserData } from '@bizzabo/entities';
import { useUserSettings } from '../../../../settingsNav';

interface Props {
    user: UserData;
}

const StartNetworkingCard: React.FC<Props> = ({ user }) => {
    const { openScheduledMeetings } = useUserSettings();
    const { trackClickEvent } = useTypeTracking();
    const classes = useStyles();

    const openSettings = () => {
        openScheduledMeetings();
        trackClickEvent({
            subCategory: 'MEETINGS_SETTINGS',
        });
    };

    return (
        <div className={classes.card}>
            <span className={classes.emoji}>☕</span>
            <Text
                variant="t50"
                className={classes.title}
            >{`${user.firstName}, Let's start networking!`}</Text>
            <Text variant="t81" className={classes.text}>
                Select an attendee from the list below, next you will be able to send him a meeting
                invite with your mutual availability. Happy networking!
            </Text>
            <MainButton
                className={classes.btnSettings}
                onClick={openSettings}
                before={<Settings className={classes.settingsIcon} />}
            >
                My meeting preferences
            </MainButton>
        </div>
    );
};

const useStyles = makeStyles(
    theme => ({
        card: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            margin: '0 24px 24px',
            padding: 24,
            borderRadius: 16,
            backgroundColor: theme.palette.greys[200],
        },
        title: {
            textAlign: 'center',
            color: theme.palette.greys[700],
        },
        text: {
            margin: '10px 0 20px',
            textAlign: 'center',
            color: theme.palette.greys[600],
        },
        emoji: {
            marginBottom: 6,
            marginLeft: 4,
            fontSize: '1.6rem',
        },
        btnSettings: {
            ...theme.typography.t80,
            height: 24,
            padding: '0 13px',
        },
        settingsIcon: {
            width: 13,
            height: 13,
        },
    }),
    { classNamePrefix: StartNetworkingCard.name }
);

export default StartNetworkingCard;
